<template>
    <div>
        <div class="content-nav-wrapper">
            <div class="title-wrapper">
                <span class="title">{{ $t('comb.myAudition') }}</span>
                <span>{{ $t('word.total') }} {{ totalCount }} {{ $t('word.item') }}</span>
            </div>
            <div class="tabs-wrapper">
                <button :class="{'active': statusCode===0}" @click="getTaskList(0, 1)"><span>{{ $t('word.all') }}</span></button>
                <button :class="{'active': statusCode===1}" @click="getTaskList(1, 1)"><span>{{ $t('word.addition') }}</span></button>
                <button :class="{'active': statusCode===2}" @click="getTaskList(2, 1)"><span>{{ $t('word.selecting') }}</span></button>
                <button :class="{'active': statusCode===3}" @click="getTaskList(3, 1)"><span>{{ $t('comb.AuditionFailure') }}</span></button>
            </div>
        </div>
        <div class="copyright-empty-task-list" v-if="totalCount === 0 && statusCode===0" >
            <span class="sub-title">为您推荐</span>
            <div class="recommend-wrapper">
                <a class="recommend-item" v-for="(recommend, index) in recommendList" target="_blank"
                   :href="`${$store.state.A_PC_HOST}/requirement/${recommend.requirementId}/candidate`">
                    <img :src="$store.state.UPLOAD_IMG_HOST+recommend.coverPath" @error="setDefaultBookCoverImg(index, 'recommendImg')" ref="recommendImg">
                    <div class="content-wrapper">
                        <div class="payment-wrapper">
                            <span class="payment">{{ getPayment(recommend) }}</span>
                            <span class="payment-label">{{ getPaymentLabel(recommend) }}</span>
                        </div>
                        <span class="requirement-name">{{ recommend.requirementName }}</span>
                        <span class="author-name">{{ recommend.authorName }} 著</span>
                        <span class="category-label">{{ recommend.categoryName }}</span>
                        <div class="audition-wrapper">
                            <span>海选剩余{{ recommend.sampleRemainTime }}</span>
                            <span>{{ recommend.candidateOrTaskWorkNum }}人参选</span>
                        </div>
                    </div>
                </a>
            </div>
            <p class="no-task">您可以通过<a :href="`${$store.state.A_PC_HOST}/requirementview`">参加海选</a>或<router-link :to="{name: 'anchorMyVoiceTag'}">添加声音标签</router-link>获得更多播讲机会</p>
        </div>
        <div class="copyright-tasks-list-wrapper" v-else v-loading.body="pageLoading">
            <div v-for="(item,index) in taskList" class="task-item">
                <div class="title">
                    <span v-if="item.viewStatusId > 2" class="status">海选失败</span>
                    <span v-else class="status">{{ item.viewStatusName }}</span>
                    <span v-if="item.viewStatusId === 1">{{ item.sampleRemainTime }}</span>
                </div>
                <div class="task-content-wrapper">
                    <img v-if="item.coverPath" class="task-cover" :src="$store.state.UPLOAD_IMG_HOST+item.coverPath" @error="setDefaultBookCoverImg(index, 'img')" ref="img">
                    <img v-else class="task-cover" :src="$store.state.IMG_HOST+'bookCoverDefault.png'">
                    <div :class="{'task-content-single': item.requirementId}" class="task-content">
                        <div class="content">
                            <span class="task-name">{{ item.requirementName }}</span>
                            <div v-if="item.author"><span class="task-anchor">{{ item.categoryName }}</span></div>
                            <span class="category-label" v-if="item.viewStatusId < 3">{{ item.candidateOrTaskWorkNum }}人参与</span>
                            <span v-else> </span>
                        </div>
                        <div class="buttons">
                            <a :href="`${$store.state.A_PC_HOST}/requirement/${item.requirementId}/candidate`" class="check-task" target="_blank">{{ $t('word.check') }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="center-tasks-pagination" v-if="totalPage>=2">
            <el-pagination :current-page="pageIndex" @current-change="pageChange" :page-count="totalPage" layout="prev, pager, next"></el-pagination>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import XiFooter from '../../components/Footer.vue';
    import XiTop from '../../components/Top.vue';
    export default {
        components: {
          axios,
          XiFooter,
          XiTop
        },
        data() {
            return {
              pageLoading: true,
              statusCode: 0,
              taskList:[],
              recommendList: [],
              pageIndex: 0,
              totalPage: 0,
              totalCount: 0
            }
        },
        beforeMount() {
            this.getTaskList(0, 1);
        },
        methods: {
          getTaskList(statusCode, pageIndex) {
            this.statusCode = statusCode;
            this.pageLoading = true;
            const that = this;
            this.pageIndex = pageIndex;
            that.taskList = null;
            axios.get(`/api/anchor/requirement/participant/status/${statusCode}/page/${this.pageIndex}`,{
            }).then(res => {
              if (res.data.code === 200) {
                that.taskList = res.data.data.items;
                that.totalPage = res.data.data.pages;
                that.totalCount = res.data.data.total;
                if(that.totalCount === 0 && that.statusCode === 0) {
                  axios.get(`/api/anchor/requirement/recommend/page/1/size/3`,{}).then(res2 => {
                    if (res2.data.code === 200) {
                      that.recommendList = res2.data.data.items;
                    }
                  });
                }
              }
              that.pageLoading = false;
            });
          },
          pageChange(page) {
            this.getTaskList(this.statusCode, page);
          },
          setDefaultBookCoverImg(index, group) {
            this.$refs[group][index].src = this.$store.state.DEFAULT_BOOK_COVER;
          },
          getPayment(recommend) {
            let result = '';
            if(!!recommend.prePayDirectMultiplier) {
              result = '￥' + recommend.prePayDirectMultiplier + '/小时';
            }
            if(!!recommend.royaltyShareRatioDecimal) {
              if (recommend.prePayDirectMultiplier) {
                result = result + '+' + recommend.royaltyShareRatioDecimal*100 + '%';
              } else {
                result = recommend.royaltyShareRatioDecimal*100 + '%';
              }
            }
            return result;
          },
          getPaymentLabel(recommend) {
            let result = '';
            if(!!recommend.prePayDirectMultiplier) {
              result = '底薪';
            }
            if(!!recommend.royaltyShareRatioDecimal) {
              if (recommend.prePayDirectMultiplier) {
                result = result + '+' + '分成';
              } else {
                result = '分成';
              }
            }
            return result;
          }
        },
        computed: {
          IMG_HOST() {
            return this.$store.state.IMG_HOST;
          }
        }
    }

</script>
<style lang="sass" scoped>
    @import "../../../sass/anchor/task-list.scss";
    @import "../../../sass/icons.scss";
</style>



// WEBPACK FOOTER //
// AuditionTasks.vue?6bd14192